/* The Science of Peachy Clean (/pages/science): scroll reveal + tab
   groups. Loaded by every peachy-sci-* section; the guard keeps it to one
   run. Tab groups: [data-psci-tabs] holding [role=tab] buttons whose
   aria-controls point at their panels; optional [data-psci-prev]/[next]. */
(function () {
  if (window.__psciBooted) return;
  window.__psciBooted = true;
  document.documentElement.classList.add('psci-js');

  function initReveal() {
    var els = document.querySelectorAll('[data-psci-reveal]');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  function initTabs(group) {
    if (group.__psciTabs) return;
    group.__psciTabs = true;
    var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
    var prev = group.querySelector('[data-psci-prev]');
    var next = group.querySelector('[data-psci-next]');
    if (!tabs.length) return;
    function select(idx, focus) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.classList.toggle('is-active', on); panel.hidden = !on; }
      });
      if (focus) tabs[idx].focus();
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === tabs.length - 1;
      group.setAttribute('data-psci-index', idx);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
      });
    });
    function current() { return parseInt(group.getAttribute('data-psci-index') || '0', 10); }
    if (prev) prev.addEventListener('click', function () { select(Math.max(0, current() - 1), false); });
    if (next) next.addEventListener('click', function () { select(Math.min(tabs.length - 1, current() + 1), false); });
    select(0, false);
  }

  function boot() {
    initReveal();
    var groups = document.querySelectorAll('[data-psci-tabs]');
    for (var i = 0; i < groups.length; i++) initTabs(groups[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function () {
    var groups = document.querySelectorAll('[data-psci-tabs]');
    for (var i = 0; i < groups.length; i++) initTabs(groups[i]);
    var els = document.querySelectorAll('[data-psci-reveal]');
    for (var j = 0; j < els.length; j++) els[j].classList.add('is-in');
  });
})();
